import script from "./CompanyProfileMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyProfileMenu.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyProfileMenu.vue?vue&type=style&index=0&id=b00cf792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b00cf792"]])

export default __exports__